export const appendUrlPrefix = (url = "") => {
  return url.startsWith("https") || url.startsWith("data:")
    ? url
    : `https://${url}`;
};
